import React, {useState, useEffect} from 'react';
import {Row, Col, Button} from '../../bootstrap/index.jsx'
import EditableList from './EditableList.jsx';
import {ACTION_TYPES} from './phaseReducer.js';
import Select from '../../common/Select.jsx';
import { PhaseInfoDialogButton } from './PhaseInfoDialogButton.jsx';

import {
  monitoring_report_save_prefill_context_path,
  monitoring_report_delete_prefill_context_path
} from '~/routes';

const EditableSelectCell = ({cell, row, updateCell, column: {id}, onChange, updateRow, options, isClearable = true, defaultValue = null}) => {
  const handleChange = val => {
    if (typeof onChange == 'function') {
      const value = onChange(val);

      if (typeof value == 'object' && (!cell.value || typeof cell.value != "object")) {
        updateRow(row.index, {...row.original, ...value})
      } else {
        updateCell(row.index, id, value)
      }
    } else {
      updateCell(row.index, id, val)
    }
  };

  const selectedOption = options.find(opt => (opt.value) == cell.value)

  return row.original.editActive ?
    <div className='input-group input-group-sm full-width'>
      <Select
        options={options}
        onChange={handleChange}
        value={cell.value}
        defaultValue={defaultValue}
        isClearable={isClearable}
        className='form-control nested-multiselect'
      />
    </div> : (selectedOption ? selectedOption.label : '-')
};

const EditableTextCell = ({cell, row, column: {id}, updateCell}) => {
  const [value, setValue] = useState(cell.value);

  const onChange = e => {
    setValue(e.target.value)
  };

  const onBlur = () => {
    updateCell(row.index, id, value)
  };

  return row.original.editActive ?
    <div className='input-group input-group-sm full-width'>
      <input className='form-control' value={value} onChange={onChange} onBlur={onBlur} />
    </div>
    :
    value
};

const ActionCell = (
  {
    row,
    updateCell,
    onSaveRow,
    onDeleteRow,
    updateRow,
    removeRow,
    discardRow
  }) => {
  const [saving, setSaving] = useState(false);

  const onCancelClick = (_e) => {
    updateCell(row.index, 'editActive', false);
    discardRow(row.index);
  };

  const onSaveClick = (_e) => {
    let row_original = row.original;
    let isNew = typeof row.id == 'string';

    if (row_original.entity_type) {
      setSaving(true);

      onSaveRow({...row_original}, (prefill_context_id) => {
        updateRow(row.index, {...row_original, editActive: false, id: prefill_context_id, new: isNew});
        setSaving(false);
      })
    }
  };

  const onDeleteClick = (_e) => {
    if (confirm(I18n.t('prefill_context_remove_confirm'))) {
      setSaving(true);
      onDeleteRow({...row.original}, () => {
        removeRow(row.index);
      })
    }
  };

  const onEditClick = (_e) => {
    updateRow(row.index, {...row.original, editActive: true, originalRow: row.original});
  };

  return <div className='pull-right'>
    { row.original.editActive ?
      <>
        <Button disabled={saving} size='sm' onClick={onSaveClick}><i className='fa fa-check'/></Button>
        <Button disabled={saving} size='sm' onClick={onCancelClick} className='ml-1' type='default'><i className='fa fa-times'/></Button>
      </>
      :
      <>
        <Button size='sm' onClick={onEditClick}><i className='fa fa-pencil'></i></Button>
        <Button disabled={saving} size='sm' onClick={onDeleteClick} className='ml-1' type='danger'><i className='fa fa-trash'/></Button>
      </>
    }
  </div>
};

const PreFillContextList = ({phase: {prefill_forms: data, id: phaseId}, report, dispatch, availablePreFillContexts}) => {
  const contextOptions = [
    {label: I18n.t('prefill_across_all_submissions'), value: 0},
    {label: I18n.t('prefill_within_current_submission'), value: 1}
  ];



  const columns = React.useMemo(
    () => [
      {
        id: 'prefill_form',
        Header: I18n.t('form'),
        accessor: ({entity_type, entity_id}) => `${entity_type}-${entity_id}`,
        Cell: (props) => <EditableSelectCell onChange={onUpdateForm} options={availablePreFillContexts} {...props} />
      },
      {
        id: 'context',
        Header: I18n.t('context'),
        accessor: ({context}) => context,
        Cell: (props) => <EditableSelectCell onChange={onUpdateContext} options={contextOptions}  isClearable={false} defaultValue={0} {...props} />
      },
      {
        id: 'level_of_importance',
        Header: I18n.t('level_of_importance'),
        accessor: ({level_of_importance}) => level_of_importance,
        Cell: EditableTextCell
      },
      {
        id: 'actions',
        Header: '',
        accessor: 'id',
        Cell: ActionCell
      }
    ].filter((c) => c),
    [availablePreFillContexts]
  );

  const onSaveRow = (row, callback) => {
    jQuery.post(monitoring_report_save_prefill_context_path({id: report.id, phase_id: phaseId, _options: true}), {prefill_context: row}, function (data) {
      dispatch({
        type: row.new ? ACTION_TYPES.ADD_PHASE_PRE_FILL_CONTEXT : ACTION_TYPES.UPDATE_PHASE_PRE_FILL_CONTEXT,
        payload: {
          newPhase: {
            entity_type: row.entity_type,
            entity_id: row.entity_id,
            level_of_importance: row.level_of_importance,
            context: row.context,
            id: data.id
          }, phaseId
        },
      });

      callback(data.id);
    })
  };

  const onDeleteRow = (row, callback) => {
    jQuery.post(monitoring_report_delete_prefill_context_path({id: report.id, prefill_context_id: row.id, phase_id: phaseId, _options: true}), {}, function (_data) {
      dispatch({type: ACTION_TYPES.REMOVE_PHASE_PRE_FILL_CONTEXT, payload: {rowId: row.id, phaseId}});
      callback(row.id);
    })
  };

  const onUpdateForm = (value) => {
    const val = value.split('-');
    return {entity_type: val[0], entity_id: val[1]};
  };

  const onUpdateContext = (value) => {
    return {context: value};
  };

  const defaultRow = React.useMemo(
    () => ({
        entity_type: null,
        entity_id: null,
        level_of_importance: 1,
        context: 0
    }),
    []
  );

  return <Row>
      <Col>
        <h3>{I18n.t('prefill_context')}
          <span>
            <PhaseInfoDialogButton
              title={I18n.t('prefill_context')}
              info={I18n.t('prefill_context_info')}
            />
          </span>
        </h3>
        <span className='description'>{I18n.t('prefill_context_description')}</span>
      </Col>
      <Col>
        <EditableList
          data={data}
          columns={columns}
          defaultRow={defaultRow}
          draggable={false}
          addRowLabel={I18n.t('add_prefill_context')}
          cellMethods={{onSaveRow: onSaveRow, onDeleteRow: onDeleteRow}}
        />
      </Col>
    </Row>
};

export default PreFillContextList;
